import { createSelector } from 'reselect';

export const getAuth = (state) => state.auth;

export const isAuthLoggedIn = createSelector(
  getAuth,
  (auth) => auth.isLoggedIn
);
export const isAuthLoading = createSelector(getAuth, ({ loading }) => loading);
export const isAuthUserInitiatedLogout = createSelector(
  getAuth,
  ({ userInitiatedLogout }) => userInitiatedLogout === true
);
export const isAuthSessionChecked = createSelector(
  getAuth,
  ({ sessionChecked }) => sessionChecked === true
);
export const getAuthError = createSelector(getAuth, ({ error }) => error);

export const isAuthRememberMe = createSelector(
  getAuth,
  ({ rememberMe }) => rememberMe
);
export const getValidateEmail = (state) =>
  state?.form?.login?.syncErrors?.email;
export const getValidatePassword = (state) => state?.form?.newPassword;

export const isAuthShowPassword = createSelector(
  getAuth,
  ({ showPassword }) => showPassword
);
export const isAuthShowNewPassword = createSelector(
  getAuth,
  ({ showNewPassword }) => showNewPassword
);
export const isAuthShowConfirmPassword = createSelector(
  getAuth,
  ({ showConfirmPassword }) => showConfirmPassword
);
export const getUserAbility = createSelector(getAuth, ({ ability }) => ability);
